var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("About page")]),_vm._v(" 14/10/2022 Nuova versione grafica In alcuni campi viene mostrato come dovrebbe essere il contunto dei campi ")])
}]

export { render, staticRenderFns }